import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { roundDecimal } from '#root/utils';
import styles from './dealsTable.module.scss';

import { SparksIcon } from '#root/icons';

const reducerQty = (accumulator, current) => Number(accumulator) + Number(current?.can);
const reducerPrice = (accumulator, current) => Number(accumulator) + Number(current?.pre);
const reducerCom = (accumulator, current) => Number(accumulator) + Number(current?.com);

const DealRow = (props) => {
  const { deal } = props;
  const orders = deal?.deal_orders;

  const qtyTotal = orders?.reduce(reducerQty, 0);
  const priceTotal = orders?.reduce(reducerPrice, 0);
  const comTotal = orders?.reduce(reducerCom, 0);
  const netCom = comTotal - Number(deal?.guvery_match_fee || 0);

  const delivery_date_aprox = deal?.fixed_real_delivery_date
    ? deal?.fixed_real_delivery_date
    : deal?.fixed_delivery_date;

  return (
    <TableRow>
      <TableCell>
        <span className={styles.dealId}>
          #{deal?.ida}
          {deal?.guvery_match_fee && <SparksIcon inlineDefault />}
        </span>
      </TableCell>
      <TableCell>
        {deal?.order?.user?.mask_fullname ? deal?.order?.user?.mask_fullname : '---'}
      </TableCell>
      <TableCell>{delivery_date_aprox}</TableCell>
      <TableCell>x {qtyTotal}</TableCell>
      <TableCell>
        <p className={styles.total}>$ {roundDecimal(priceTotal)}</p>
      </TableCell>
      <TableCell>
        <p className={styles.total}>$ {roundDecimal(netCom)}</p>
      </TableCell>
    </TableRow>
  );
};

interface DealsTableProps {
  deals?: any;
}

const DealsTable = (props: DealsTableProps) => {
  const { deals = [] } = props;

  return (
    <TableContainer>
      <Table className={styles.table}>
        <TableHead className={styles.header}>
          <TableRow>
            <TableCell>Acuerdo</TableCell>
            <TableCell>Comprador</TableCell>
            <TableCell>Entrega aprox.</TableCell>
            <TableCell>Pedidos</TableCell>
            <TableCell>Precio</TableCell>
            <TableCell>Comisión</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deals?.map((deal, index) => (
            <DealRow key={index} deal={deal} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DealsTable;
